import { FC } from 'react';
import { HiOutlineDocumentText, HiOutlineXMark } from 'react-icons/hi2';

interface EmptyStateProps {
  title: string;
  message: string;
  icon?: 'file' | 'error';
}

export const EmptyState: FC<EmptyStateProps> = ({ title, message, icon = 'file' }) => {
  return (
    <div className="bg-day-light-3 w-full flex flex-col items-center justify-center min-h-[60vh] rounded-lg">
      {icon === 'error' ? (
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
          <HiOutlineXMark className="w-8 h-8 text-red-600" />
        </div>
      ) : (
        <HiOutlineDocumentText className="h-12 w-12 text-day-neutral-subtle mb-4" />
      )}
      <div className="text-day-neutral-subtle text-xl font-medium">{title}</div>
      <p className="text-night-light-5 mt-2">{message}</p>
    </div>
  );
};
